import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import NewModal from 'react-responsive-modal';
import { manifestActions } from '../_actions';
import { config } from '../_helpers';
import { AlertPopup } from '../_components/AlertPopup';
import { withRouter } from 'react-router-dom';
import ReactModal from 'react-modal';
import DatePicker from 'react-datepicker';
import {
  getStandardCurrentDatePST,
  formatStandardDate,
} from '_helpers/helpers';
import moment from 'moment';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import { userStatus } from '_constants';
import { MANIFEST_TYPE } from './constants';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';

ReactModal.setAppElement('#app');

const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);
  return result;
};

// Define the sorting order
const colorOrder = ['Blue', 'Red', 'Yellow', 'White'];

// Custom sorting function
const sortByColor = (a, b) => {
  return colorOrder.indexOf(a.colorcode) - colorOrder.indexOf(b.colorcode);
};

const move = (source, destination, droppableSource, droppableDestination) => {
  const sourceClone = Array.from(source);
  const destClone = Array.from(destination);
  const [removed] = sourceClone.splice(droppableSource.index, 1);

  destClone.splice(droppableDestination.index, 0, removed);

  const result = {};
  result[droppableSource.droppableId] = sourceClone;
  result[droppableDestination.droppableId] = destClone;

  return result;
};

const grid = 2;

const currentDate = getStandardCurrentDatePST();

class SortYourCrew extends Component {
  constructor(props) {
    super(props);
    this.state = {
      resource_id: this.props.match?.params ? this.props.match.params.id : null,
      confirmation: false,
      anyUnavailableCrew: false,
      originalCrews: [],
      touch_id: '',
      h1: this.props.edit ? 'Edit Manifest' : 'Create Manifest',
      alertPop: false,
      items: [],
      selected: [],
      displayEffectiveDatePopup: false,
      assignedManifest: false,
      assignedDateOn: null,
      assignedDateOff: null,
      isLoading: true,
      pendingAssignmentHistoryUpdates: [], // Store assignment history updates to be called after manifest update
      type: this.props.type,
    };
    this.goToType = this.goToType.bind(this);
    this.toProjectPositionSelection =
      this.toProjectPositionSelection.bind(this);
    this.goBack = this.goBack.bind(this);
    this.onImageError = this.onImageError.bind(this);
    this.closeAlert = this.closeAlert.bind(this);
    this.confirmationOpenModal = this.confirmationOpenModal.bind(this);
    this.confirmationCloseModal = this.confirmationCloseModal.bind(this);
    this.effectiveDatePopup = this.effectiveDatePopup.bind(this);
    this.effectiveDatePopupCloseModal =
      this.effectiveDatePopupCloseModal.bind(this);
    this.handleDateChange = this.handleDateChange.bind(this);
  }

  confirmationOpenModal() {
    this.setState({ confirmation: true });
  }

  confirmationCloseModal(flag = false) {
    let anyUnavailableCrew = this.state.anyUnavailableCrew;
    this.setState({
      confirmation: false,
      anyUnavailableCrew: anyUnavailableCrew,
    });
  }

  onSelect(hash, event) {
    const selectedValue = event.target.value;

    this.setState((prevState) => {
      // Find the index of the item to update based on the hash
      const updatedItems = prevState.items.map((item) => {
        if (item.hash === hash) {
          return { ...item, incident_pos: selectedValue }; // Update the incident_pos
        }
        return item;
      });

      return { items: updatedItems }; // Update the state with modified items
    });
  }

  effectiveDatePopupCloseModal() {
    this.setState({
      displayEffectiveDatePopup: false,
    });
  }

  componentDidMount() {
    let anyUnavailableCrew;
    let oncrewList = [],
      offcrewList = [];
    this.setState({
      assignedManifest: this.props.assignedManifest,
      assignedDateOn: this.props.assignedDateOn,
      assignedDateOff: this.props.assignedDateOff,
      originalCrews: this.props.originalCrews,
    });
    if (!this.props.edit) {
      if (!this.props.prev) {
        let data = new FormData();
        var mid = sessionStorage.getItem('MID');
        data.append('resource_id', this.state.resource_id);
        if (mid == 4) {
          data.append('base_manifest_type', mid);
        } else {
          data.append('base_manifest_type', this.props.type);
        }
        this.props.dispatch(manifestActions.getUsers(data));
      } else {
        this.props.savedCrews.forEach((t) => {
          if (t.category === 'oncrew') {
            oncrewList.push(t);
          } else if (t.category === 'offcrew') {
            offcrewList.push(t);
          }
        });

        this.setState(
          {
            items: oncrewList,
            selected: offcrewList,
            isLoading: false,
          },
          () => {
            if (this.state.items.length > 0) {
              anyUnavailableCrew = this.state.items.some((item) => {
                return item.active == 'Unavailable';
              });
              this.setState({
                anyUnavailableCrew: anyUnavailableCrew,
              });
            }
          },
        );
      }
    } else {
      if (!this.props.prev) {
        let data = new FormData();
        data.append('resource_id', this.state.resource_id);
        data.append('manifest_id', this.props.manifest_id);
        data.append('base_manifest_type', this.props.type);
        this.props.dispatch(manifestActions.getUsers(data));
      } else {
        this.props.savedCrews.forEach((t) => {
          if (t.category === 'oncrew') {
            oncrewList.push(t);
          } else if (t.category === 'offcrew') {
            offcrewList.push(t);
          }
        });
        this.setState(
          {
            items: oncrewList,
            selected: offcrewList,
            isLoading: false,
          },
          () => {
            if (this.state.items.length > 0) {
              anyUnavailableCrew = this.state.items.some((item) => {
                return item.active == 'Unavailable';
              });
              this.setState({
                anyUnavailableCrew: anyUnavailableCrew,
              });
            }
          },
        );
      }
    }
  }

  componentWillReceiveProps(nextProps) {
    const { crews } = nextProps;
    let anyUnavailableCrew;
    if (crews.list) {
      const { data, additional_data } = crews.list;

      if (data.length > 0) {
        this.arrayFilter(data);
      }

      this.setState({
        originalCrews: data,
        assignedManifest: additional_data.is_manifest_assigned,
        assignedDateOn: additional_data.date_on,
        assignedDateOff: additional_data.date_off,
      });
    }
    if (crews.list?.data) {
      anyUnavailableCrew = crews.list.data.some((item) => {
        return item.active == 'Unavailable';
      });
      this.setState({
        anyUnavailableCrew: anyUnavailableCrew,
      });
    }
  }

  // Priority order for qualifications (position based on dropdown options)
  // Note: Trainee positions (T) are excluded from auto-selection
  getQualificationPriority = () => {
    switch (this.state.type?.toString()) {
      case MANIFEST_TYPE.NCC:
      case MANIFEST_TYPE.ODF:
      case MANIFEST_TYPE.WA:
      case MANIFEST_TYPE.TYPE_2:
        return ['CRWB', 'FFTI/ICT5', 'FFTI', 'FFTII'];
      case MANIFEST_TYPE.VIPR:
        return ['ENGB', 'FFTI', 'FFTII'];
      case MANIFEST_TYPE.PROJECT_MANIFEST:
        return [
          'Project Superindent',
          'CRWB',
          'ENGB',
          'FFTI/ICT5',
          'FFTI',
          'FFTII',
          'Sawyer',
          'Saftey Officer',
          'Crew Member',
        ];
      case MANIFEST_TYPE.DCRM:
        return ['Project Superindent', 'Crew Member'];
      default:
        return [
          'Project Superindent',
          'CRWB',
          'ENGB',
          'FFTI/ICT5',
          'FFTI',
          'FFTII',
          'Crew Member',
          'Sawyer',
          'Saftey Officer',
        ];
    }
  };

  // ==================== Qualification Helper Methods ====================

  /**
   * Check if a user has a specific qualification (case-insensitive)
   */
  hasQualification = (qualifications, targetQual) => {
    if (!qualifications?.length) return false;
    const target = targetQual.toUpperCase();
    return qualifications.some((q) => q?.toUpperCase() === target);
  };

  /**
   * Check if user has both FFTI and ICT5 qualifications (combined qualification)
   */
  hasCombinedFFTIAndICT5 = (qualifications) => {
    return (
      this.hasQualification(qualifications, 'FFTI') &&
      this.hasQualification(qualifications, 'ICT5')
    );
  };

  /**
   * Check if a priority position matches the user's qualifications
   */
  matchesPriorityPosition = (qualifications, priority) => {
    if (priority.includes('/')) {
      const [qual1, qual2] = priority
        .split('/')
        .map((q) => q.replace('(T)', ''));
      return (
        this.hasQualification(qualifications, qual1) &&
        this.hasQualification(qualifications, qual2)
      );
    }
    return this.hasQualification(qualifications, priority.replace('(T)', ''));
  };

  /**
   * Check if manifest type is NCC, ODF, or Type 2
   */
  isCrewManifestType = (manifestType) => {
    return [
      MANIFEST_TYPE.NCC,
      MANIFEST_TYPE.ODF,
      MANIFEST_TYPE.WA,
      MANIFEST_TYPE.TYPE_2,
    ].includes(manifestType);
  };

  /**
   * Get the highest qualification for a user based on priority list
   */
  getHighestQualification = (qualifications, priorityList) => {
    if (!qualifications?.length) return null;

    for (const priority of priorityList) {
      if (priority === 'Project Superindent' || priority.includes('(T)'))
        continue;

      if (this.matchesPriorityPosition(qualifications, priority)) {
        return priority;
      }
    }
    return null;
  };

  /**
   * Get the second highest qualification for a user based on priority list
   */
  getSecondHighestQualification = (qualifications, priorityList) => {
    if (!qualifications?.length) return null;

    let foundFirst = false;
    for (const priority of priorityList) {
      if (priority === 'Project Superindent' || priority.includes('(T)'))
        continue;

      if (this.matchesPriorityPosition(qualifications, priority)) {
        if (foundFirst) return priority;
        foundFirst = true;
      }
    }
    return null;
  };

  /**
   * Get the next available qualification excluding a specific position
   */
  getNextAvailableQualification = (
    qualifications,
    excludePosition,
    priorityList,
  ) => {
    if (!qualifications?.length) return null;

    for (const priority of priorityList) {
      if (priority === excludePosition || priority.includes('(T)')) continue;

      if (this.matchesPriorityPosition(qualifications, priority)) {
        return priority;
      }
    }
    return null;
  };

  /**
   * Determine highest qualification position using standard priority order
   * Priority: CRWB > ENGB > FFTI/ICT5 > FFTI > FFTII
   */
  determineHighestQualificationPosition = (
    qualifications,
    priorityList,
    fallback = '',
  ) => {
    if (this.hasQualification(qualifications, 'CRWB')) return 'CRWB';
    if (this.hasQualification(qualifications, 'ENGB')) return 'ENGB';
    if (this.hasCombinedFFTIAndICT5(qualifications)) return 'FFTI/ICT5';
    if (this.hasQualification(qualifications, 'FFTI')) return 'FFTI';
    if (this.hasQualification(qualifications, 'FFTII')) return 'FFTII';

    return (
      this.getHighestQualification(qualifications, priorityList) || fallback
    );
  };

  /**
   * Determine secondary qualification position (excludes CRWB)
   * Priority: FFTI/ICT5 > FFTI > FFTII
   */
  determineSecondaryQualificationPosition = (
    qualifications,
    priorityList,
    fallback = '',
  ) => {
    if (this.hasCombinedFFTIAndICT5(qualifications)) return 'FFTI/ICT5';
    if (this.hasQualification(qualifications, 'FFTI')) return 'FFTI';
    if (this.hasQualification(qualifications, 'FFTII')) return 'FFTII';

    return (
      this.getSecondHighestQualification(qualifications, priorityList) ||
      fallback
    );
  };

  // ==================== Auto-Assignment Logic ====================

  /**
   * Auto-assign incident positions based on qualifications, roles, and manifest type
   */
  autoAssignIncidentPositions = (crewList) => {
    const manifestType = this.state.type?.toString();
    const priorityList = this.getQualificationPriority();

    // Track superintendent assignments for position logic
    const context = {
      superintendentCount: 0,
      projectSuperintendentCount: 0,
      firstSuperintendentPosition: null,
    };

    return crewList.map((member) => {
      const qualifications = member.qualification || [];
      const isSuperintendent = member.user_type === 'Superintendent';

      const assignedPosition = this.assignPositionByManifestType(
        manifestType,
        isSuperintendent,
        qualifications,
        priorityList,
        member,
        context,
      );

      return { ...member, incident_pos: assignedPosition };
    });
  };

  /**
   * Assign position based on manifest type and user role
   */
  assignPositionByManifestType = (
    manifestType,
    isSuperintendent,
    qualifications,
    priorityList,
    member,
    context,
  ) => {
    let position = null;

    // Route to appropriate handler based on manifest type
    if (manifestType === MANIFEST_TYPE.PROJECT_MANIFEST) {
      position = this.assignProjectManifestPosition(
        isSuperintendent,
        qualifications,
        priorityList,
        member,
        context,
      );
    } else if (this.isCrewManifestType(manifestType)) {
      position = this.assignCrewManifestPosition(
        isSuperintendent,
        qualifications,
        priorityList,
        member,
        context,
      );
    } else if (manifestType === MANIFEST_TYPE.VIPR && isSuperintendent) {
      position = this.assignVIPRSuperintendentPosition(
        qualifications,
        priorityList,
        context,
      );
    }

    // Fallback to existing position or highest qualification
    return position || member.incident_pos || member.highq || '';
  };

  /**
   * Handle position assignment for Project Manifest
   */
  assignProjectManifestPosition = (
    isSuperintendent,
    qualifications,
    priorityList,
    member,
    context,
  ) => {
    if (isSuperintendent) {
      context.projectSuperintendentCount++;

      switch (context.projectSuperintendentCount) {
        case 1:
          return 'Project Superindent';
        case 2:
          return 'CRWB';
        default:
          return this.determineHighestQualificationPosition(
            qualifications,
            priorityList,
            member.highq,
          );
      }
    }

    // Non-superintendent: assign highest qualification
    return this.determineHighestQualificationPosition(
      qualifications,
      priorityList,
      member.highq,
    );
  };

  /**
   * Handle position assignment for NCC/ODF/Type 2 Manifests
   */
  assignCrewManifestPosition = (
    isSuperintendent,
    qualifications,
    priorityList,
    member,
    context,
  ) => {
    if (isSuperintendent) {
      context.superintendentCount++;
      const memberHighestQual = this.getHighestQualification(
        qualifications,
        priorityList,
      );

      if (context.superintendentCount === 1) {
        // First superintendent gets their highest qualification
        context.firstSuperintendentPosition = memberHighestQual || member.highq;
        return context.firstSuperintendentPosition;
      }

      // Subsequent superintendents: check for conflict with first
      if (memberHighestQual === context.firstSuperintendentPosition) {
        // Same qualification as first - assign secondary position
        return this.determineSecondaryQualificationPosition(
          qualifications,
          priorityList,
          memberHighestQual || member.highq,
        );
      }

      // Different qualification - use their highest
      return memberHighestQual || member.highq;
    }

    // Non-superintendent: assign highest qualification (excluding ENGB for crew manifests)
    if (this.hasQualification(qualifications, 'CRWB')) return 'CRWB';
    if (this.hasCombinedFFTIAndICT5(qualifications)) return 'FFTI/ICT5';
    if (this.hasQualification(qualifications, 'FFTI')) return 'FFTI';
    if (this.hasQualification(qualifications, 'FFTII')) return 'FFTII';

    return (
      this.getHighestQualification(qualifications, priorityList) || member.highq
    );
  };

  /**
   * Handle position assignment for VIPR Manifest superintendents
   */
  assignVIPRSuperintendentPosition = (
    qualifications,
    priorityList,
    context,
  ) => {
    context.superintendentCount++;

    if (context.superintendentCount === 1) {
      return 'ENGB';
    }

    return (
      this.getNextAvailableQualification(
        qualifications,
        'ENGB',
        priorityList,
      ) || 'ENGB'
    );
  };

  arrayFilter(data) {
    var oncrewList = [],
      offcrewList = [];
    data.forEach((t) => {
      if (t.category === 'oncrew') {
        oncrewList.push(t);
      } else if (t.category === 'offcrew') {
        offcrewList.push(t);
      }
    });

    // Apply auto-assignment logic for on-crew members
    oncrewList = this.autoAssignIncidentPositions(oncrewList);

    this.setState({
      items: oncrewList,
      selected: offcrewList,
      isLoading: false,
    });
  }

  closeAlert() {
    this.setState({
      alertPop: false,
    });
  }

  goToType(type) {
    if (!this.props.edit) {
      this.props.previous(type);
    } else {
      this.props.cancel(this.state.resource_id);
    }
  }

  goBack() {
    this.props.cancel(this.state.resource_id);
  }

  onImageError(e) {
    e.target.setAttribute('src', config.apiUrl + '/' + config.altImg);
  }

  handleDateChange = (date, user, listType) => {
    this.setState((prevState) => {
      const key = listType == 'items' ? 'date_on' : 'date_off';
      let defaultDate = currentDate;
      if (key == 'date_off') {
        defaultDate =
          currentDate >= user.assignment_date_on
            ? currentDate
            : user.assignment_date_on;
      }

      // Determine if we’re updating items or selected
      const updatedList = prevState[listType].map((item) =>
        item.hash === user.hash
          ? { ...item, [key]: date ? formatStandardDate(date) : defaultDate }
          : item,
      );

      return {
        [listType]: updatedList,
      };
    });
  };

  handleHotlineShiftChange = (event, userHash) => {
    const { value } = event.target;
    if (!isNaN(value) && Number(value) >= 0) {
      // Ensure non-negative numbers
      this.setState((prevState) => ({
        selected: prevState['selected'].map((user) =>
          user.hash === userHash
            ? { ...user, hotline_shifts: value }
            : { ...user, hotline_shifts: user.hotline_shifts },
        ),
      }));
    }
  };

  effectiveDatePopup() {
    let displayEffectiveDatePopup = false;

    if (this.state.assignedManifest) {
      const originalCrews = this.state.originalCrews;
      const items = this.state.items; // oncrew
      const selected = this.state.selected; // offcrew

      // Create a map of original crews for easy access
      const originalMap = new Map(
        originalCrews.map((user) => [user.hash, user]),
      );

      // Process items (oncrew)
      const modifiedItems = items.map((user) => {
        const originalUser = originalMap.get(user.hash);
        const require_date_on =
          originalUser?.category === 'oncrew' ? false : true; // True if the user is offcrew now
        let date_on = null;
        if (require_date_on) {
          displayEffectiveDatePopup = true;

          if (this.state.assignedDateOff) {
            date_on = user.date_on
              ? user.date_on
              : currentDate >= this.state.assignedDateOn &&
                  currentDate <= this.state.assignedDateOff
                ? currentDate
                : this.state.assignedDateOn;
          } else {
            date_on = user.date_on
              ? user.date_on
              : currentDate >= this.state.assignedDateOn
                ? currentDate
                : this.state.assignedDateOn;
          }
        }
        return {
          ...user,
          require_date_on,
          date_on,
          require_date_off: false,
          date_off: null,
        }; // Spread original user properties and add require_date_off
      });

      // Process selected (offcrew)
      const modifiedSelected = selected.map((user) => {
        const originalUser = originalMap.get(user.hash);
        const require_date_off =
          originalUser?.category === 'offcrew' ? false : true; // True if the user is oncrew now
        let date_off = null;
        if (require_date_off) {
          displayEffectiveDatePopup = true;

          if (this.state.assignedDateOff) {
            date_off = user.date_off
              ? user.date_off
              : currentDate >= this.state.assignedDateOn &&
                  currentDate <= this.state.assignedDateOff
                ? currentDate
                : user.assignment_date_on;
          } else {
            date_off = user.date_off
              ? user.date_off
              : currentDate >= this.state.assignedDateOn
                ? currentDate
                : user.assignment_date_on;
          }
        }
        return {
          ...user,
          require_date_off,
          date_off,
          require_date_on: false,
          date_on: null,
        }; // Spread original user properties and add require_date_on
      });

      // Update state with modified lists
      this.setState({
        items: modifiedItems,
        selected: modifiedSelected,
        displayEffectiveDatePopup: displayEffectiveDatePopup,
      });
    }

    if (!displayEffectiveDatePopup) {
      this.toProjectPositionSelection();
    }
  }

  /**
   * Check if a position value is valid for the current manifest type
   */
  isValidPosition = (position) => {
    if (!position || position === '' || position === '--') {
      return false;
    }
    const validPositions = this.getValidPositionValues();
    return validPositions.includes(position);
  };

  toProjectPositionSelection = async () => {
    // Validate that all crew members have valid incident positions assigned
    const hasInvalidPosition = this.state.items.some(
      (crew) => !this.isValidPosition(crew.incident_pos),
    );

    if (hasInvalidPosition) {
      return toast.error('Please assign a position to all crew members.');
    }

    // Validate trainee positions count based on manifest type
    const traineesCount = this.state.items.filter(
      (crew) => crew.incident_pos && crew.incident_pos.includes('(T)'),
    ).length;

    const manifestType = this.state.type?.toString();
    const maxTrainees = manifestType === MANIFEST_TYPE.VIPR ? 1 : 3;

    if (traineesCount > maxTrainees) {
      const errorMessage =
        manifestType === MANIFEST_TYPE.VIPR
          ? 'Cannot have more than 1 crew members with trainee positions'
          : 'Cannot have more than 3 crew members with trainee positions';
      toast.error(errorMessage);
      return;
    }

    if (this.state.assignedManifest) {
      const unfilledHotlineShiftUsers = this.state.selected.filter(
        (user) => user.require_date_off && !user.hotline_shifts,
      );

      if (unfilledHotlineShiftUsers.length > 0) {
        return toast.error('Hotline Shifts is a required field.');
      }
    }

    if (this.props.edit && this.props.manifest_id) {
      // Get all users that were moved to Off Crew (require_date_off = true)
      const unassignedUsers = this.state.selected.filter(
        (user) => user.require_date_off,
      );

      // Get all users that were moved to On Crew (require_date_on = true)
      const assignedUsers = this.state.items.filter(
        (user) => user.require_date_on,
      );

      // Store assignment history updates to be called after manifest update
      const pendingUpdates = [];

      // Prepare unassigned user updates
      for (const user of unassignedUsers) {
        pendingUpdates.push({
          manifest_id: this.props.manifest_id,
          user_hash: user.hash,
          action: 'unassign',
          date_off: user.date_off || new Date().toISOString().split('T')[0],
          hotline_shifts: user.hotline_shifts || 0,
        });
      }

      // Prepare assigned user updates
      for (const user of assignedUsers) {
        pendingUpdates.push({
          manifest_id: this.props.manifest_id,
          user_hash: user.hash,
          action: 'assign',
          date_on: user.date_on || new Date().toISOString().split('T')[0],
        });
      }

      // Store pending updates in state
      this.setState({
        pendingAssignmentHistoryUpdates: pendingUpdates,
      });
    }

    const onCrewValidated = this.checkForUnAvailableInOnCrew();
    if (onCrewValidated) {
      var crews = [];
      if (this.state.items.length > 0) {
        var on = this.state.items;
        this.state.selected.map((item, index) => {
          on.push(item);
          return on;
        });
        crews = on;
        this.props.next(crews, this.executePendingAssignmentHistoryUpdates);
        this.props.storeAssignedManifest(this.state.assignedManifest);
        this.props.storeAssignedDateOn(this.state.assignedDateOn);
        this.props.storeAssignedDateOff(this.state.assignedDateOff);
        this.props.storeOriginalCrews(this.state.originalCrews);
      } else {
        this.setState({
          alertPop: true,
          alertHead: 'Error',
          alertMsg: 'Select at least 1 user',
          alertFunction: '',
        });
      }
    } else {
      this.setState({ anyUnavailableCrew: true }, () => {
        this.confirmationOpenModal();
      });
    }
  };

  checkForUnAvailableInOnCrew() {
    let isUnavailable = true;
    const onCrew = this.state.items;
    if (onCrew?.length) {
      for (const crew of onCrew) {
        if (
          crew.active === 'Unavailable' ||
          crew.userstatus == userStatus.Guest
        ) {
          isUnavailable = false;
          break;
        }
      }
    }
    return isUnavailable;
  }

  // Method to execute pending assignment history updates
  executePendingAssignmentHistoryUpdates = async () => {
    const { pendingAssignmentHistoryUpdates } = this.state;

    if (pendingAssignmentHistoryUpdates.length === 0) {
      return;
    }

    try {
      // Execute all pending updates
      for (const update of pendingAssignmentHistoryUpdates) {
        try {
          await this.props.dispatch(
            manifestActions.updateUserAssignmentHistory(update),
          );
        } catch (error) {
          const user =
            this.state.items.find((u) => u.hash === update.user_hash) ||
            this.state.selected.find((u) => u.hash === update.user_hash);
          const userName = user
            ? `${user.first_name} ${user.last_name}`
            : 'Unknown user';
          toast.error(`Failed to update assignment history for ${userName}`);
          throw error;
        }
      }

      toast.success('Assignment history updated successfully');

      // Clear pending updates after successful execution
      this.setState({
        pendingAssignmentHistoryUpdates: [],
      });
    } catch (error) {
      toast.error('Error updating assignment history. Please try again.');
      throw error;
    }
  };

  handleOnWheel = (e) => {
    e.preventDefault();
    e.stopPropagation();
    e.target.blur();
  };

  modifyAssignment = (item, assignmentStatus) => {
    this.setState((prevState) => {
      let updatedItems, updatedSelected;

      if (assignmentStatus) {
        item.require_date_on = true;
        item.date_on = null;
        item.require_date_off = false;
        item.date_off = null;

        // Add to `items` if not present and remove from `selected`
        const existsInItems = prevState.items.some(
          (existingItem) => existingItem.userid === item.userid,
        );
        updatedItems = existsInItems
          ? prevState.items
          : [...prevState.items, item];
        updatedSelected = prevState.selected.filter(
          (existingItem) => existingItem.userid !== item.userid,
        );
      } else {
        item.require_date_on = false;
        item.date_on = null;
        item.require_date_off = true;
        item.date_off = null;

        // Add to `selected` if not present and remove from `items`
        const existsInSelected = prevState.selected.some(
          (existingItem) => existingItem.userid === item.userid,
        );
        updatedSelected = existsInSelected
          ? prevState.selected
          : [...prevState.selected, item];
        updatedItems = prevState.items.filter(
          (existingItem) => existingItem.userid !== item.userid,
        );
      }

      // Update categories within the new `selected` and `items` arrays
      updatedSelected = updatedSelected.map((t) => ({
        ...t,
        category: 'offcrew',
      }));
      updatedItems = updatedItems.map((t) => ({ ...t, category: 'oncrew' }));

      // Update and sort updatedSelected by color
      updatedSelected = updatedSelected
        .map((t) => ({
          ...t,
          category: 'offcrew',
        }))
        .sort(sortByColor);

      // Update and sort updatedItems by color
      updatedItems = updatedItems
        .map((t) => ({
          ...t,
          category: 'oncrew',
        }))
        .sort(sortByColor);

      return {
        selected: updatedSelected,
        items: updatedItems,
      };
    });

    let anyUnavailableCrew;
    if (this.state.items) {
      anyUnavailableCrew = this.state.items.some((item) => {
        return item.active == 'Unavailable';
      });
      this.setState({
        anyUnavailableCrew: anyUnavailableCrew,
      });
    }
  };

  onDragEnd = (result) => {
    const { source, destination } = result;

    // Dropped outside any droppable
    if (!destination) return;

    // Don't allow cross-list dragging
    if (source.droppableId !== destination.droppableId) return;

    const listKey = source.droppableId; // either 'items' or 'selected'
    const reorderedList = Array.from(this.state[listKey]);
    const [movedItem] = reorderedList.splice(source.index, 1);
    reorderedList.splice(destination.index, 0, movedItem);

    // set category and sort by color
    const updatedList = reorderedList
      .map((item) => ({
        ...item,
        category: listKey === 'items' ? 'oncrew' : 'offcrew',
      }))
      .sort(sortByColor);

    this.setState({
      [listKey]: updatedList,
    });

    // Update unavailable crew flag if 'items' changed
    if (listKey === 'items') {
      const anyUnavailableCrew = updatedList.some(
        (item) => item.active === 'Unavailable',
      );
      this.setState({ anyUnavailableCrew });
    }
  };

  /**
   * Get valid position values for the current manifest type
   * Used for validation to ensure auto-assigned positions are valid dropdown options
   */
  getValidPositionValues = () => {
    switch (this.state.type?.toString()) {
      case MANIFEST_TYPE.DCRM:
        return ['Project Superindent', 'Crew Member'];
      case MANIFEST_TYPE.NCC:
        return [
          'CRWB',
          'CRWB(T)',
          'FFTI',
          'FFTI(T)',
          'FFTII',
          'FFTI/ICT5',
          'FFTI/ICT(T)',
        ];
      case MANIFEST_TYPE.ODF:
        return [
          'CRWB',
          'CRWB(T)',
          'FFTI',
          'FFTI(T)',
          'FFTII',
          'FFTI/ICT5',
          'FFTI/ICT(T)',
        ];
      case MANIFEST_TYPE.WA:
        return [
          'CRWB',
          'CRWB(T)',
          'FFTI',
          'FFTI(T)',
          'FFTII',
          'FFTI/ICT5',
          'FFTI/ICT(T)',
        ];
      case MANIFEST_TYPE.TYPE_2:
        return [
          'CRWB',
          'CRWB(T)',
          'FFTI',
          'FFTI(T)',
          'FFTII',
          'FFTI/ICT5',
          'FFTI/ICT(T)',
        ];
      case MANIFEST_TYPE.VIPR:
        return ['ENGB', 'ENGB(T)', 'FFTI', 'FFTII'];
      case MANIFEST_TYPE.PROJECT_MANIFEST:
        return [
          'CRWB',
          'CRWB(T)',
          'ENGB',
          'FFTI/ICT5',
          'FFTI/ICT(T)',
          'FFTI',
          'FFTI(T)',
          'FFTII',
          'Project Superindent',
          'Crew Member',
          'Sawyer',
          'Saftey Officer',
        ];
      default:
        return [
          'CRWB/ICT4',
          'CRWB/ICT5',
          'CRWB',
          'CRWB(T)',
          'ENGB/ICT4',
          'ENGB/ICT5',
          'ENGB',
          'ENGB(T)',
          'FFTI/ICT5',
          'FFTI/ICT5(T)',
          'FFTI',
          'FFTI(T)',
          'ICT5(T)',
          'FFTII',
          'RXB3',
          'RXB3(T)',
          'ENG(T)',
        ];
    }
  };

  renderOptions = () => {
    switch (this.state.type?.toString()) {
      case MANIFEST_TYPE.DCRM:
        return (
          <>
            <option value=''>--</option>
            <option value='Project Superindent'>Project Superindent</option>
            <option value='Crew Member'>Crew Member</option>
          </>
        );
      case MANIFEST_TYPE.NCC:
        return (
          <>
            <option value=''>--</option>
            <option value='CRWB'>CRWB</option>
            <option value='CRWB(T)'>CRWB(T)</option>
            <option value='FFTI'>FFTI</option>
            <option value='FFTI(T)'>FFTI(T)</option>
            <option value='FFTII'>FFTII</option>
            <option value='FFTI/ICT5'>FFTI/ICT5</option>
            <option value='FFTI/ICT(T)'>FFTI/ICT(T)</option>
          </>
        );
      case MANIFEST_TYPE.ODF:
        return (
          <>
            <option value=''>--</option>
            <option value='CRWB'>CRWB</option>
            <option value='CRWB(T)'>CRWB(T)</option>
            <option value='FFTI'>FFTI</option>
            <option value='FFTI(T)'>FFTI(T)</option>
            <option value='FFTII'>FFTII</option>
            <option value='FFTI/ICT5'>FFTI/ICT5</option>
            <option value='FFTI/ICT(T)'>FFTI/ICT(T)</option>
          </>
        );
      case MANIFEST_TYPE.TYPE_2:
        return (
          <>
            <option value=''>--</option>
            <option value='CRWB'>CRWB</option>
            <option value='CRWB(T)'>CRWB(T)</option>
            <option value='FFTI'>FFTI</option>
            <option value='FFTI(T)'>FFTI(T)</option>
            <option value='FFTII'>FFTII</option>
            <option value='FFTI/ICT5'>FFTI/ICT5</option>
            <option value='FFTI/ICT(T)'>FFTI/ICT(T)</option>
          </>
        );
      case MANIFEST_TYPE.WA:
        return (
          <>
            <option value=''>--</option>
            <option value='CRWB'>CRWB</option>
            <option value='CRWB(T)'>CRWB(T)</option>
            <option value='FFTI'>FFTI</option>
            <option value='FFTI(T)'>FFTI(T)</option>
            <option value='FFTII'>FFTII</option>
            <option value='FFTI/ICT5'>FFTI/ICT5</option>
            <option value='FFTI/ICT(T)'>FFTI/ICT(T)</option>
          </>
        );
      case MANIFEST_TYPE.VIPR:
        return (
          <>
            <option value=''>--</option>
            <option value='ENGB'>ENGB</option>
            <option value='ENGB(T)'>ENGB(T)</option>
            <option value='FFTI'>FFTI</option>
            <option value='FFTII'>FFTII</option>
          </>
        );
      case MANIFEST_TYPE.PROJECT_MANIFEST:
        return (
          <>
            <option value=''>--</option>
            <option value='CRWB'>CRWB</option>
            <option value='CRWB(T)'>CRWB(T)</option>
            <option value='ENGB'>ENGB</option>
            <option value='FFTI/ICT5'>FFTI/ICT5</option>
            <option value='FFTI/ICT(T)'>FFTI/ICT(T)</option>
            <option value='FFTI'>FFTI</option>
            <option value='FFTI(T)'>FFTI(T)</option>
            <option value='FFTII'>FFTII</option>
            <option value='Project Superindent'>Project Superindent</option>
            <option value='Crew Member'>Crew Member</option>
            <option value='Sawyer'>Sawyer</option>
            <option value='Saftey Officer'>Saftey Officer</option>
          </>
        );
      default:
        return (
          <>
            <option value=''>--</option>
            <option value='CRWB/ICT4'>CRWB/ICT4</option>
            <option value='CRWB/ICT5'>CRWB/ICT5</option>
            <option value='CRWB'>CRWB</option>
            <option value='CRWB(T)'>CRWB(T)</option>
            <option value='ENGB/ICT4'>ENGB/ICT4</option>
            <option value='ENGB/ICT5'>ENGB/ICT5</option>
            <option value='ENGB'>ENGB</option>
            <option value='ENGB(T)'>ENGB(T)</option>
            <option value='FFTI/ICT5'>FFTI/ICT5</option>
            <option value='FFTI/ICT5(T)'>FFTI/ICT5(T)</option>
            <option value='FFTI'>FFTI</option>
            <option value='FFTI(T)'>FFTI(T)</option>
            <option value='ICT5(T)'>ICT5(T)</option>
            <option value='FFTII'>FFTII</option>
            <option value='RXB3'>RXB3</option>
            <option value='RXB3(T)'>RXB3(T)</option>
            <option value='ENG(T)'>ENG(T)</option>
          </>
        );
    }
  };

  render() {
    // var i=1, j = 1;
    return (
      <div>
        <NewModal
          id=''
          className=''
          open={this.state.confirmation}
          onClose={this.confirmationCloseModal.bind(this)}
        >
          <div id='statusPopup'>
            <div className='modal-head'>
              <h4 className='modal-title'>Confirm</h4>
            </div>
            <div className='modal-body'>
              <p>
                On crew list contains unvailable employees, please review or
                click on Next button to continue.
              </p>
              <br />
              {/* <button className="button m-r-1" onClick={this.confirmationCloseModal}>Cancel</button> */}
              <button
                className='button'
                onClick={() => this.confirmationCloseModal(true)}
              >
                Close
              </button>
            </div>
          </div>
        </NewModal>
        <ReactModal
          isOpen={this.state.displayEffectiveDatePopup}
          onClose={this.effectiveDatePopupCloseModal.bind(this)}
        >
          <div id='statusPopup' className='resources-popup fr-resources-popup'>
            <div className='modal-head'>
              <h4 className='modal-title'>Confirm Effective Date</h4>
            </div>
            <div className='modal-body'>
              <p>
                Please select the effective date of the employee's addition or
                removal from the crew. The selected effective dates will update
                the employee's fire history.
              </p>
              {(() => {
                let showOncrewTitle = true;
                let showOffcrewTitle = true;

                return (
                  <>
                    {/* Loop through items (oncrew members) */}
                    {this.state.items?.map((user) =>
                      user.require_date_on ? (
                        <React.Fragment key={`item-${user.hash}`}>
                          {showOncrewTitle && (
                            <h6>
                              Effective Dates for Addition of Employees to the
                              Manifest
                            </h6>
                          )}
                          {
                            (showOncrewTitle = false) /* Set flag to false after first iteration */
                          }
                          <div className='user-date-input'>
                            <figure>
                              <img
                                className={
                                  user.active === 'Available'
                                    ? 'active'
                                    : 'inactive'
                                }
                                src={
                                  user.profile_photo
                                    ? config.apiUrl + '/' + user.profile_photo
                                    : config.apiUrl + '/' + config.altImg
                                }
                                alt={user.last_name}
                                onError={this.onImageError.bind(this)}
                              />
                            </figure>
                            <span className=''>
                              {user.first_name + ' ' + user.last_name}
                            </span>
                            <DatePicker
                              type='date'
                              required
                              id={`date_on_${user.hash}`}
                              placeholderText='Date On'
                              name={`date_on_${user.hash}`}
                              selected={
                                user.date_on ? moment(user.date_on) : null
                              }
                              onChange={(date) =>
                                this.handleDateChange(date, user, 'items')
                              }
                              showMonthDropdown
                              showYearDropdown
                              dropdownMode='select'
                              autoComplete='off'
                              minDate={
                                this.state.assignedDateOn
                                  ? moment(this.state.assignedDateOn)
                                  : null
                              }
                              maxDate={
                                this.state.assignedDateOff
                                  ? moment(this.state.assignedDateOff)
                                  : null
                              }
                              onKeyDown={(e) => e.preventDefault()}
                            />
                          </div>
                        </React.Fragment>
                      ) : null,
                    )}

                    {/* Loop through selected (offcrew members) */}
                    {this.state.selected?.map((user) =>
                      user.require_date_off ? (
                        <React.Fragment key={`selected-${user.hash}`}>
                          {showOffcrewTitle && (
                            <h6>
                              Effective Dates for Removal of Employees from the
                              Manifest
                            </h6>
                          )}
                          {
                            (showOffcrewTitle = false) /* Set flag to false after first iteration */
                          }
                          <div className='user-date-input'>
                            <figure>
                              <img
                                className={
                                  user.active === 'Available'
                                    ? 'active'
                                    : 'inactive'
                                }
                                src={
                                  user.profile_photo
                                    ? config.apiUrl + '/' + user.profile_photo
                                    : config.apiUrl + '/' + config.altImg
                                }
                                alt={user.last_name}
                                onError={this.onImageError.bind(this)}
                              />
                            </figure>
                            <span className=''>
                              {user.first_name + ' ' + user.last_name}
                            </span>
                            <DatePicker
                              type='date'
                              required
                              id={`date_off_${user.hash}`}
                              placeholderText='Date Off'
                              name={`date_off_${user.hash}`}
                              selected={
                                user.date_off ? moment(user.date_off) : null
                              }
                              onChange={(date) =>
                                this.handleDateChange(date, user, 'selected')
                              }
                              showMonthDropdown
                              showYearDropdown
                              dropdownMode='select'
                              autoComplete='off'
                              minDate={
                                user.assignment_date_on
                                  ? moment(user.assignment_date_on)
                                  : null
                              }
                              maxDate={
                                this.state.assignedDateOff
                                  ? moment(this.state.assignedDateOff)
                                  : null
                              }
                              onKeyDown={(e) => e.preventDefault()}
                            />
                            <input
                              type='number'
                              style={{ width: '20%' }}
                              className='hotline_shifts'
                              name={`hotline_shifts_${user.hash}`}
                              id={`hotline_shifts_${user.hash}`}
                              field={`hotline_shifts_${user.hash}`}
                              placeholder='Hotline Shifts'
                              value={user.hotline_shifts}
                              min={0}
                              onWheel={this.handleOnWheel}
                              onKeyDown={(evt) =>
                                evt.key === 'e' && evt.preventDefault()
                              }
                              onChange={(event) =>
                                this.handleHotlineShiftChange(event, user.hash)
                              }
                            />
                          </div>
                        </React.Fragment>
                      ) : null,
                    )}
                  </>
                );
              })()}
              <br />
            </div>
            <div className='btn_list'>
              <button
                className='button grey'
                onClick={() => this.effectiveDatePopupCloseModal()}
              >
                Cancel
              </button>
              <button
                className='button'
                onClick={() => this.toProjectPositionSelection()}
              >
                Submit
              </button>
            </div>
          </div>
        </ReactModal>
        <div className='applicants_container sort_your_crew'>
          <div className='breadcrumbs'>
            <Link to={'/resources'} className='green'>
              Resources
            </Link>{' '}
            / <span onClick={this.goBack.bind(this)}>Details</span> / Select
            Crew Members and Position
          </div>
          <div className='page_title float'>
            <h1>{this.state.h1}</h1>
          </div>
          <div className='manifest_type'>
            <div className='inner_head'>
              <h3>Select Crew Members and Position</h3>
            </div>
            <div className='content_div inner_container '>
              <div className='sort_crew_div'>
                <div className='drag_sort_wrap'>
                  <div>
                    <div className='row-flex'>
                      <div className='heading-section task-header'>On Crew</div>
                      <div className='heading-section task-header hide-mobile'>
                        Off Crew
                      </div>
                    </div>
                    <DragDropContext onDragEnd={this.onDragEnd}>
                      <div className='ft sort-crew'>
                        <div className='sort-crew__on-crew'>
                          <Droppable droppableId='items'>
                            {(provided) => (
                              <ul
                                role='list'
                                ref={provided.innerRef}
                                {...provided.droppableProps}
                              >
                                {this.state.items?.map((item, index) => (
                                  <Draggable
                                    key={item.hash}
                                    draggableId={`items-${item.hash}`}
                                    index={index}
                                  >
                                    {(provided) => (
                                      <li
                                        ref={provided.innerRef}
                                        {...provided.draggableProps}
                                        {...provided.dragHandleProps}
                                      >
                                        <div
                                          className={`sort-crew__card ${item.colorcode}`}
                                        >
                                          <article>
                                            <span className='sort-crew__number'>
                                              {index + 1}
                                            </span>
                                            <figure>
                                              <img
                                                className={
                                                  item.userstatus ==
                                                  userStatus.Guest
                                                    ? 'pending'
                                                    : item.active ===
                                                        'Available'
                                                      ? 'active'
                                                      : 'inactive'
                                                }
                                                src={
                                                  item.profile_photo
                                                    ? config.apiUrl +
                                                      '/' +
                                                      item.profile_photo
                                                    : config.apiUrl +
                                                      '/' +
                                                      config.altImg
                                                }
                                                alt={item.last_name}
                                                onError={this.onImageError.bind(
                                                  this,
                                                )}
                                              />
                                            </figure>
                                            <span className='sort-crew__name'>
                                              {item.first_name +
                                                ' ' +
                                                item.last_name}
                                            </span>
                                          </article>
                                          <div className='sort-crew__position'>
                                            <select
                                              value={item.incident_pos || ''}
                                              onChange={this.onSelect.bind(
                                                this,
                                                item.hash,
                                              )}
                                            >
                                              {this.renderOptions()}
                                            </select>
                                          </div>
                                          <footer>
                                            <button
                                              onClick={this.modifyAssignment.bind(
                                                this,
                                                item,
                                                false,
                                              )}
                                              className='sort-crew__btn button grey'
                                            >
                                              unassign
                                            </button>
                                          </footer>
                                        </div>
                                      </li>
                                    )}
                                  </Draggable>
                                ))}
                                {provided.placeholder}
                                {!this.state.isLoading &&
                                  !this.state.items?.length &&
                                  'No Employees'}
                              </ul>
                            )}
                          </Droppable>
                        </div>
                        <div className='sort-crew__off-crew'>
                          <div className='row-flex hide-desk'>
                            <div className='heading-section task-header'>
                              Off Crew
                            </div>
                          </div>
                          <Droppable droppableId='selected'>
                            {(provided) => (
                              <ul
                                role='list'
                                ref={provided.innerRef}
                                {...provided.droppableProps}
                              >
                                {this.state.selected?.map((item, index) => (
                                  <Draggable
                                    key={item.hash}
                                    draggableId={`selected-${item.hash}`}
                                    index={index}
                                  >
                                    {(provided) => (
                                      <li
                                        ref={provided.innerRef}
                                        {...provided.draggableProps}
                                        {...provided.dragHandleProps}
                                      >
                                        <div
                                          className={`sort-crew__card ${item.colorcode}`}
                                        >
                                          <article>
                                            <span className='sort-crew__number'>
                                              {index + 1}
                                            </span>
                                            <figure>
                                              <img
                                                className={
                                                  item.userstatus ==
                                                  userStatus.Guest
                                                    ? 'pending'
                                                    : item.active ===
                                                        'Available'
                                                      ? 'active'
                                                      : 'inactive'
                                                }
                                                src={
                                                  item.profile_photo
                                                    ? config.apiUrl +
                                                      '/' +
                                                      item.profile_photo
                                                    : config.apiUrl +
                                                      '/' +
                                                      config.altImg
                                                }
                                                alt={item.last_name}
                                                onError={this.onImageError.bind(
                                                  this,
                                                )}
                                              />
                                            </figure>
                                            <span className='sort-crew__name'>
                                              {item.first_name +
                                                ' ' +
                                                item.last_name}
                                            </span>
                                          </article>
                                          <footer>
                                            <button
                                              onClick={this.modifyAssignment.bind(
                                                this,
                                                item,
                                                true,
                                              )}
                                              className='sort-crew__btn button'
                                            >
                                              assign
                                            </button>
                                          </footer>
                                        </div>
                                      </li>
                                    )}
                                  </Draggable>
                                ))}
                                {provided.placeholder}
                                {!this.state.isLoading &&
                                  !this.state.selected?.length &&
                                  'No Employees'}
                              </ul>
                            )}
                          </Droppable>
                        </div>
                      </div>
                    </DragDropContext>
                  </div>
                </div>
                <div className='clearFix' />
                <div className='btn_list'>
                  <button
                    className='button grey'
                    onClick={this.goToType.bind(this, this.props.type)}
                  >
                    Previous
                  </button>
                  <button
                    className='button'
                    onClick={() => this.effectiveDatePopup()}
                  >
                    Next
                  </button>
                </div>
              </div>
            </div>
          </div>
          {this.state.alertPop && (
            <AlertPopup
              head={this.state.alertHead}
              message={this.state.alertMsg}
              viewOpen='true'
              alertFunction={this.state.alertFunction}
              close={this.closeAlert.bind(this)}
            />
          )}
        </div>
      </div>
    );
  }
}

SortYourCrew.propTypes = {
  match: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  crews: PropTypes.array,
  previous: PropTypes.func.isRequired,
  edit: PropTypes.bool,
  manifest_id: PropTypes.string,
  prev: PropTypes.bool,
  type: PropTypes.string.isRequired,
  assignedManifest: PropTypes.bool,
  assignedDateOn: PropTypes.string,
  assignedDateOff: PropTypes.string,
  originalCrews: PropTypes.array,
  savedCrews: PropTypes.array,
  next: PropTypes.func.isRequired,
  cancel: PropTypes.func.isRequired,
  storeAssignedManifest: PropTypes.func.isRequired,
  storeAssignedDateOn: PropTypes.func.isRequired,
  storeAssignedDateOff: PropTypes.func.isRequired,
  storeOriginalCrews: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
  const { crews } = state;
  return {
    crews,
  };
}

const connectedResourcePage = withRouter(
  connect(mapStateToProps)(SortYourCrew),
);
export { connectedResourcePage as SortYourCrew };
